var map = {
	"./marksix-1.svg": 95370,
	"./marksix-10.svg": 81686,
	"./marksix-11.svg": 45511,
	"./marksix-12.svg": 97300,
	"./marksix-13.svg": 69909,
	"./marksix-14.svg": 46698,
	"./marksix-15.svg": 7067,
	"./marksix-16.svg": 72680,
	"./marksix-17.svg": 38073,
	"./marksix-18.svg": 95550,
	"./marksix-19.svg": 22927,
	"./marksix-2.svg": 56121,
	"./marksix-20.svg": 17867,
	"./marksix-21.svg": 40346,
	"./marksix-22.svg": 85161,
	"./marksix-23.svg": 59800,
	"./marksix-24.svg": 4727,
	"./marksix-25.svg": 15750,
	"./marksix-26.svg": 47525,
	"./marksix-27.svg": 50276,
	"./marksix-28.svg": 13555,
	"./marksix-29.svg": 26178,
	"./marksix-3.svg": 31848,
	"./marksix-30.svg": 6888,
	"./marksix-31.svg": 19257,
	"./marksix-32.svg": 69962,
	"./marksix-33.svg": 22427,
	"./marksix-34.svg": 61076,
	"./marksix-35.svg": 82709,
	"./marksix-36.svg": 62422,
	"./marksix-37.svg": 9287,
	"./marksix-38.svg": 28720,
	"./marksix-39.svg": 42222,
	"./marksix-4.svg": 51655,
	"./marksix-40.svg": 73045,
	"./marksix-41.svg": 51412,
	"./marksix-42.svg": 99623,
	"./marksix-43.svg": 52758,
	"./marksix-44.svg": 9593,
	"./marksix-45.svg": 97224,
	"./marksix-46.svg": 12763,
	"./marksix-47.svg": 60298,
	"./marksix-48.svg": 55421,
	"./marksix-49.svg": 26876,
	"./marksix-5.svg": 64534,
	"./marksix-6.svg": 5781,
	"./marksix-7.svg": 80148,
	"./marksix-8.svg": 36579,
	"./marksix-9.svg": 98642,
	"./marksix-F_ch.svg": 17609,
	"./marksix-F_en.svg": 36425,
	"./marksix-gold-1.svg": 90821,
	"./marksix-gold-10.svg": 13375,
	"./marksix-gold-11.svg": 75438,
	"./marksix-gold-12.svg": 86157,
	"./marksix-gold-13.svg": 34348,
	"./marksix-gold-14.svg": 91091,
	"./marksix-gold-15.svg": 76866,
	"./marksix-gold-16.svg": 40913,
	"./marksix-gold-17.svg": 352,
	"./marksix-gold-18.svg": 5559,
	"./marksix-gold-19.svg": 59110,
	"./marksix-gold-2.svg": 59046,
	"./marksix-gold-20.svg": 20682,
	"./marksix-gold-21.svg": 54875,
	"./marksix-gold-22.svg": 73512,
	"./marksix-gold-23.svg": 81433,
	"./marksix-gold-24.svg": 6198,
	"./marksix-gold-25.svg": 93319,
	"./marksix-gold-26.svg": 5460,
	"./marksix-gold-27.svg": 47445,
	"./marksix-gold-28.svg": 23954,
	"./marksix-gold-29.svg": 61891,
	"./marksix-gold-3.svg": 64375,
	"./marksix-gold-30.svg": 357,
	"./marksix-gold-31.svg": 45636,
	"./marksix-gold-32.svg": 72407,
	"./marksix-gold-33.svg": 1222,
	"./marksix-gold-34.svg": 3817,
	"./marksix-gold-35.svg": 52600,
	"./marksix-gold-36.svg": 7787,
	"./marksix-gold-37.svg": 88730,
	"./marksix-gold-38.svg": 79853,
	"./marksix-gold-39.svg": 140,
	"./marksix-gold-4.svg": 19448,
	"./marksix-gold-40.svg": 62264,
	"./marksix-gold-41.svg": 13481,
	"./marksix-gold-42.svg": 98394,
	"./marksix-gold-43.svg": 17451,
	"./marksix-gold-44.svg": 55300,
	"./marksix-gold-45.svg": 10021,
	"./marksix-gold-46.svg": 10886,
	"./marksix-gold-47.svg": 82071,
	"./marksix-gold-48.svg": 22944,
	"./marksix-gold-49.svg": 69393,
	"./marksix-gold-5.svg": 44809,
	"./marksix-gold-6.svg": 83642,
	"./marksix-gold-7.svg": 77515,
	"./marksix-gold-8.svg": 50636,
	"./marksix-gold-9.svg": 97997
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61713;